import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import HomeS from '../components/HomeS'
import HomeC from '../components/HomeC'
import Contact from '../components/Contact'
import Mqtt from '../components/Mqtt'

import MaoBigdataKol from '../components/bigdata/BigdataKol.vue'
import MaoBigdataLogin from '../components/bigdata/BigdataLogin'
import MaoBigdataKolList from '../components/bigdata/BigdataKolList'
import MaoBigdataNote from '../components/bigdata/BigdataNote'
import MaoBigdataNoteList from '../components/bigdata/BigdataNoteList'
import MaoBigdataNoteHot from '../components/bigdata/BigdataNoteHot'
import MaoBigdataNoteBaobei from '../components/bigdata/BigdataNoteBaobei'
import MaoBigdataSensitiveWord from '../components/bigdata/BigdataSensitiveWord'
import MaoBigdataNoteRead from '../components/bigdata/BigdataNoteRead'

import XiaoHongShu from '../components/zhaomu/XiaoHongShu'
import DouYin from '../components/zhaomu/DouYin'
import DianPing from '../components/zhaomu/DianPing'
import Dewu from '../components/zhaomu/Dewu'
import Weibo from '../components/zhaomu/Weibo'
import BB from '../components/zhaomu/BB'
import GG from '../components/zhaomu/Guangguang.vue'

import KaSi from '../components/kasi/KaSi.vue'

import Test from '../components/test/Test.vue'

import YYLogin from '../components/yaoyue/YYLogin.vue'
import YYRequestEdit from '../components/yaoyue/YYRequestEdit.vue'
import YYRequestList from '../components/yaoyue/YYRequestList.vue'
import YYAccountList from "../components/yaoyue/YYAccountList.vue";
import YYZhaomu from '../components/yaoyue/YYZhaomu.vue'
import YYZhaomuList from '../components/yaoyue/YYZhaomuList.vue'

Vue.use(VueRouter);


export default new VueRouter({
  routes: [
    {
      // 路由跳转路径
      path: '/yyzhaomu',
      // 路由名称
      name: 'yyzhaomu',
      // 路由跳转组件
      component: YYZhaomu
    },{
      // 路由跳转路径
      path: '/yyzhaomus',
      // 路由名称
      name: 'yyzhaomus',
      // 路由跳转组件
      component: YYZhaomuList
    },{
      // 路由跳转路径
      path: '/yyaccounts',
      // 路由名称
      name: 'yyaccounts',
      // 路由跳转组件
      component: YYAccountList
    },{
      // 路由跳转路径
      path: '/yyrequest_edit',
      // 路由名称
      name: 'yyrequest_edit',
      // 路由跳转组件
      component: YYRequestEdit
    },{
      // 路由跳转路径
      path: '/yyrequests',
      // 路由名称
      name: 'yyrequests',
      // 路由跳转组件
      component: YYRequestList
    },{
      // 路由跳转路径
      path: '/yylogin',
      // 路由名称
      name: 'yylogin',
      // 路由跳转组件
      component: YYLogin
    },{
      // 路由跳转路径
      path: '',
      // 路由名称
      name: 'home',
      // 路由跳转组件
      component: Home
    },{
      // 大数据智慧种草
      path: '/homes',
      // 路由名称
      name: 'homes',
      // 路由跳转组件
      component: HomeS
    },{
      // 关于我们
      path: '/homec',
      // 路由名称
      name: 'homec',
      // 路由跳转组件
      component: HomeC
    },{
      // 路由跳转路径
      path: '/kasi',
      // 路由名称
      name: 'kasi',
      // 路由跳转组件
      component: KaSi
    },{
      // 路由跳转路径
      path: '/test',
      // 路由名称
      name: 'test',
      // 路由跳转组件
      component: Test
    },{
      // 路由跳转路径
      path: '/contact',
      // 路由名称
      name: 'contact',
      // 路由跳转组件
      component: Contact
    },{
      // 路由跳转路径
      path: '/noteread',
      // 路由名称
      name: 'noteread',
      // 路由跳转组件
      component: MaoBigdataNoteRead
    },{
      // 路由跳转路径
      path: '/bigdata',
      // 路由名称
      name: 'bigdata',
      // 路由跳转组件
      component: MaoBigdataKol
    },{
      // 路由跳转路径
      path:'/login',
      // 路由名称
      name:'login',
      // 路由跳转组件
      component:MaoBigdataLogin
    },{
      // 路由跳转路径
      path:'/word',
      // 路由名称
      name:'word',
      // 路由跳转组件
      component:MaoBigdataSensitiveWord
    },{
      // 路由跳转路径
      path:'/kollist',
      // 路由名称
      name:'kollist',
      // 路由跳转组件
      component:MaoBigdataKolList
    },{
      // 路由跳转路径
      path:'/notelist',
      // 路由名称
      name:'notelist',
      // 路由跳转组件
      component:MaoBigdataNoteList
    },{
      // 路由跳转路径
      path:'/note',
      // 路由名称
      name:'note',
      // 路由跳转组件
      component:MaoBigdataNote
    },{
      // 路由跳转路径
      path:'/notehot',
      // 路由名称
      name:'notehot',
      // 路由跳转组件
      component:MaoBigdataNoteHot
    },{
      // 路由跳转路径
      path:'/notebaobei',
      // 路由名称
      name:'notebaobei',
      // 路由跳转组件
      component:MaoBigdataNoteBaobei
    },{
      // 路由跳转路径
      path: '/xhs_zhaomu',
      // 路由名称
      name: 'xhs',
      // 路由跳转组件
      component: XiaoHongShu
    },{
      // 路由跳转路径
      path: '/dy_zhaomu',
      // 路由名称
      name: 'dy',
      // 路由跳转组件
      component: DouYin
    },{
      // 路由跳转路径
      path: '/dp_zhaomu',
      // 路由名称
      name: 'dp',
      // 路由跳转组件
      component: DianPing
    },{
      // 路由跳转路径
      path: '/dw_zhaomu',
      // 路由名称
      name: 'dw',
      // 路由跳转组件
      component: Dewu
    },{
      // 路由跳转路径
      path: '/wb_zhaomu',
      // 路由名称
      name: 'wb',
      // 路由跳转组件
      component: Weibo
    },{
      // 路由跳转路径
      path: '/bb_zhaomu',
      // 路由名称
      name: 'bb',
      // 路由跳转组件
      component: BB
    },{
      // 路由跳转路径
      path: '/gg_zhaomu',
      // 路由名称
      name: 'gg',
      // 路由跳转组件
      component: GG
    },{
      path: '/mqtt',
      // 路由名称
      name: 'mqtt',
      // 路由跳转组件
      component: Mqtt
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js